import { createSelector } from '@reduxjs/toolkit';
import { CampaignType } from 'components/pages/Planner/PlannerSections/types';
import { Store } from 'components/common/types/Store.types';
import { FeatureFlags } from 'components/common/types/Features.types';

export const getCampaignType = createSelector(
  (state: Store) => state.dealManagement.campaignType,
  (state: Store) => state.publisher.publisherFeatures,
  (state: Store) => state.environment.environmentId,
  (campaignType, publisherFeatures, environmentId) => {
    const hasDirectSalesFeature =
      publisherFeatures?.[FeatureFlags.DIRECT_SALES_PLANNER]?.includes(environmentId) ?? false;
    const isDirectSalesCampaignType = hasDirectSalesFeature && campaignType === CampaignType.DIRECT;
    const isProgrammaticCampaignType = !isDirectSalesCampaignType;

    return {
      hasDirectSalesFeature,
      isProgrammaticCampaignType,
      isDirectSalesCampaignType,
    };
  },
);

export const getIsDirectSalesCampaignType = createSelector(
  getCampaignType,
  ({ isDirectSalesCampaignType }) => isDirectSalesCampaignType,
);

export const getIsProgrammaticCampaignType = createSelector(
  getCampaignType,
  ({ isProgrammaticCampaignType }) => isProgrammaticCampaignType,
);
